module.exports = __webpack_public_path__ + "static/media/no-message-illustration.cfc091c3.svg";